module.exports = __webpack_public_path__ + "static/media/check-mark.ea75ebce.png";